module.exports = __webpack_public_path__ + "media/ware.799220ab.mp4";